import { InputComponent } from '@/shared/components/input.component';
import {
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  Component,
  Input,
  ContentChild,
  TemplateRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { Observable } from 'rxjs';

type Value = string | Record<string, any>;

@Component({
  selector: 'app-input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss'],
})
export class InputSelectComponent
  extends InputComponent<Value>
  implements AfterViewInit, OnChanges {
  @ContentChild(TemplateRef) templateRef!: TemplateRef<any>;

  @Input() options: Value[] = [];
  @Input() optionLabel: string = 'name';
  @Input() appearance: MatFormFieldAppearance = "fill";
  @Input() isDisabled: boolean = false;
  @Input() valueFirst: string = '';

  filteredOptions: Observable<Value[]> | undefined;
  inputFormControl = new FormControl();

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['options'] &&
      changes['options'].currentValue !== changes['options'].previousValue
    ) {
      this.options = changes['options'].currentValue;
    }
  }

  ngAfterViewInit(): void {
    this.inputFormControl.valueChanges.subscribe(() => {
      this.onChange(this.inputFormControl.value);
    });
  }

  _optionLabel(option: Value): string {
    if (typeof option === 'string') {
      return option;
    }
    return option?.[this.optionLabel] || '';
  }

  displayFn = (value: Value): string => {
    return this._optionLabel(value);
  };
}
